<template>
    <div>
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-privacy-register"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div class="modal-base-body">
                    <div class="page-wrapper">
                        <div class="page-bg"></div>
                        <div class="page-content">
                            <TopBarDark
                                :title="title"
                                @clickBack="clickBack()">
                            </TopBarDark>
                            <div class="privacy-page">
                                <div class="wrapper-privacy" @scroll="onScroll()"
                                     ref="privacyRegisterModal">
                                    <div class="text-detail" v-html="privacyContent"></div>
                                </div>
                                <div class="btn">
                                    <div class="btn-accept" v-if="bottomOfContent"  @click="clickOk()">
                                        <div class="btn-txt">
                                            {{lbl.static.marketing.btn_accept}}
                                        </div>
                                    </div>
                                    <div class="btn-accept disabled" v-else>
                                        <div class="btn-txt">
                                            {{lbl.static.marketing.btn_accept}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer">

                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//component
import TopBarDark from "@/components/Layout/TopBarPage/TopBarDark.vue"
//service
import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA.js";
/**
 * @property {ProductDescriptionModalController} controller (required)../Controller/ProductDescriptionModalController.js
 * @property {String} modalId (reqquired)
 */

export default {
    name: "PrivacyRegisterModal",
    props: {
        controller: Object,
        modalId: String,
        loadingModal: Object, //loding modal from master controller
    },
    components: {
        TopBarDark,
    },
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    data: function() {
        return {
            title: "",
            message: "",
            btnOk: "",
            tag: "",
            busModal: null,
            privacyContent: null,
            type: "",
            bottomOfContent: false,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;

    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        initialPDPA: function () {
            return new Promise((resolve, reject) => {
                BzbsPDPA.apiGetPDPAVersion()
                .subscribe((data) => {
                    resolve(data);
                    BzbsPDPA.apiGetPDPAContent(this.type, data.privacy, this.localeCode)
                    .subscribe((data) => {
                        this.privacyContent = data;
                        this.$bvModal.show(this.modalId);
                        resolve(data);
                    }, (err) => {
                        this.errorApi(err);
                        reject(err);
                    });
                }, (err) => {
                    this.errorApi(err);
                    reject(err);
                })
            });
        },
        onScroll () {
            const element = this.$refs.privacyRegisterModal;
            const clientHeight = element.clientHeight
            const scrollHeight = element.scrollHeight
            const scrollTop = element.scrollTop
            if (scrollTop + clientHeight >= scrollHeight-28) {
                this.bottomOfContent = true;
            }else{
                this.bottomOfContent = false;
            }
        },
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        onOk: function() {
            if(this.bottomOfContent){
                this.controller.sendCallbackOk(true);
            }
                this.hide();
        },
        clickOk: function() {
            this.onOk();
        },
        clickBack: function(){
            this.hide();
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            this.type = config.type;
            this.bottomOfContent = false;

            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.title = this.lbl.static.privacy.title_topbar;
            this.initialPDPA();
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseText.scss";
@import "@/style/base/baseDisplay.scss";
@import '@/style/input/BaseButton.scss';
.modal-privacy-register{
    .page-wrapper {
        .page-bg {
            background-color: $white;
        }
    }
    .privacy-page {
        @include bg-curve();
        position: absolute;
        bottom: unset;
        padding: 20px 25px 10px;
        .wrapper-privacy {
            background-color: $light-blue;
            border-radius: 30px;
            width: 100%;
            max-height: 75vh;
            overflow-y: auto;
            overflow-x: hidden;
            @include scrollbar($pink, white);

            @include mini-mobile(){
                height: 68vh;
            }

            .text-detail {
                font-size: 1.1rem;
                line-height: 1.56;
                text-align: left;
                font-size: 18px;
                line-height: 1.56;
                margin: 10px 20px;
                color: $black;

                @include mini-mobile(){
                    font-size: 0.9rem;
                }
            }
        }
        .btn {
            position: fixed;
            // bottom: -15px;
            right: 0;
            left: 0;
            padding: 8px 30px 0;
            .btn-accept{
                @include btn-wrapper();
                margin: 8px auto 25px;

                &:disabled {
                    opacity: 0.3;
                }

                @include mini-mobile(){
                    min-height: 40px;

                }
                @include middle-mobile() {
                    margin: 0 auto 8px;
                }
            }
        }
    }
}

</style>

<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-privacy-register{
    .modal-dialog{
        margin: 0;

        .modal-content{
            border: 0;

            .modal-body{
                padding: 0;
            }
        }
    }
}
</style>
